/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import ConfirmModal from './ConfirmModal/index'
import React from 'react'
import TysiaToggle from 'DesignSystem/TysiaToggle/index'
import TysiaToggleButton from 'DesignSystem/TysiaToggle/TysiaToggleButton/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/ToggleLocationConnection/DisableConnectionForLocationAction/Content"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<TysiaToggle
  viewPath={`${viewPath}/TysiaToggle`}
 value={true}
 marginLeft="auto"
 marginTop={0}
 onChange={() => setFlowTo(fromFlow.normalizePath(viewPath, 'ConfirmModal/Content'))}
>
{childProps => (
<TysiaToggleButton
{...childProps}
  viewPath={`${viewPath}/TysiaToggleButton`}
/>
)}
</TysiaToggle>
<ConfirmModal
  viewPath={`${viewPath}/ConfirmModal`}
/>
{children}
</React.Fragment>)
}